module.exports = __webpack_public_path__ + "static/assets/13a5d6cb60a2dd226321ed4dccadbc60.svg";